import { getChatSessionDetails } from "../../modules/vscDashboard/dashboard.service";
import { getADKChatSessionDetails, getFilesFromRagCorpus } from "../../services/adk.service";
import {
  AdkReferenceFile,
  ADKTtcChatHistoryRow,
  TtcChatHistoryRow,
} from "../AntdTable/AntdTable.model";

export const LAZY_LOADED_ENTITIES = {
  TTC_CHAT_HISTORY: "TTC_CHAT_HISTORY",
  ADK_TTC_CHAT_FILES: "ADK_TTC_CHAT_FILES",
    ADK_TTC_CHAT_HISTORY : "ADK_TTC_CHAT_HISTORY"
};

export const entityDataMapper = {
  [LAZY_LOADED_ENTITIES.TTC_CHAT_HISTORY]: {
    dataModel: TtcChatHistoryRow,
    columns: [],
    listApi: getChatSessionDetails,
    dataRowKey: "results",
  },
  [LAZY_LOADED_ENTITIES.ADK_TTC_CHAT_FILES]: {
    dataModel: AdkReferenceFile,
    columns: [],
    listApi: getFilesFromRagCorpus,
    dataRowKey: "files",
    checkMoreDataKey: "next_page_token",
  },
  [LAZY_LOADED_ENTITIES.ADK_TTC_CHAT_HISTORY]: {
    dataModel: ADKTtcChatHistoryRow,
    columns: [],
    listApi: getADKChatSessionDetails,
    dataRowKey : "results"
  },
};

export const VERTICAL_TO_RAG_MAP = {
  "Core ML": {
    name: "Core_ML",
    id: "4749045807062188032",
  },
  "Customer Support": {
    name: "Customer_Support",
    id: "5613736935517323264",
  },
  "Deal Ops": {
    name: "Deal_Ops",
    id: "8207810320882728960",
  },
  Engineering: {
    name: "Engineering",
    id: "3019663550151917568",
  },
  GPS: {
    name: "GPS",
    id: "6478428063972458496",
  },
  "Learning Services": {
    name: "Learning_Services",
    id: "425590164786511872",
  },
  Marketing: {
    name: "Marketing",
    id: "7343119192427593728",
  },
  Sales: {
    name: "Sales",
    id: "3884354678607052800",
  },
};
